import { render } from "./NoticePopup.vue?vue&type=template&id=7f19704d&ts=true"
import script from "./NoticePopup.vue?vue&type=script&lang=ts"
export * from "./NoticePopup.vue?vue&type=script&lang=ts"

import "./NoticePopup.vue?vue&type=style&index=0&id=7f19704d&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__